import { Button, Drawer, Form, Input, InputRef, Modal, Select, Space } from "antd";
import Table, { ColumnsType } from "antd/es/table";
import { connect } from "react-redux";
import { AppState } from "src/store";
import style from './Tables.module.scss'
import { useEffect, useRef, useState } from "react";
import { getAllTransformation, GetTransformationById, postRegisterTransformation, putUpdateTransformation } from "src/store/transformationfactors/thunks";
import { SearchOutlined, PlusCircleOutlined, LockOutlined, UserOutlined, CreditCardOutlined, MailOutlined, PhoneOutlined, EditOutlined } from '@ant-design/icons';
import { SizeType } from "antd/es/config-provider/SizeContext";
import validateMessages from "src/globals/Inputs/validateMessages";
import TextArea from "antd/es/input/TextArea";
import form from "antd/es/form";
import { NamePath } from "antd/es/form/interface";
import { TransformationSource } from "src/store/transformationfactors/types";
import { validate1, validate150 } from "src/globals/Inputs/validateInput";
import { getUserByToken } from "src/store/user/thunks";
import { ColumnType, FilterConfirmProps } from "antd/es/table/interface";


interface TableProps {
    getAllTransformation?: any;
    GetTransformationById?: any;
    postRegisterTransformation?: any;
    putUpdateTransformation?: any;
    getUserByToken?:any;
}

/*id:string
    name:string,
    type:string,    
    description:string,
    created_at:string*/

interface DataType {
    key: string;
    id: string;
    flow: string;
    feUnit: string;
    baseUnit: string;   
    unit: string;
    operation: string;
    number: string;
    source: string;
    description: string;
    created_at: string;
    
    updated_at: string;
}

type DataIndex = keyof DataType;
type RequiredMark = boolean | 'optional';
const TFactorst: React.FC<TableProps> = (props: TableProps) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isFormValidate, setIsFormValidate] = useState(true);
    const [typeModal, setTypeModal] = useState(true);
    const [idFactor, setIdFactor] = useState('');
    const [formValidate] = Form.useForm();
    const [requiredMark, setRequiredMarkType] = useState<RequiredMark>('optional');
    const [componentSize, setComponentSize] = useState<SizeType | 'default'>('default');

    const searchInput = useRef<InputRef>(null);
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const { Option } = Select;
    //LLamar al EndPoint tanto en el Iterface como en el Map, 

    const [isRol, setIsRol] = useState('');
  
      



    const init = async () => {
        const rol = await props.getUserByToken();
        setIsRol(rol);
        const responseDataFactors = await props.getAllTransformation();
        setDataTable(responseDataFactors);
    }
    useEffect(() => {
        init();
    }, []);

    //Crear una tabla.
    const [dataTable, setDataTable] = useState([]);


    
    const handleSearch = (
        selectedKeys: string[],
        confirm: (param?: FilterConfirmProps) => void,
        dataIndex: DataIndex,
    ) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters: () => void) => {
        clearFilters();
        setSearchText('');
    };    
    const getColumnSearchProps = (dataIndex: DataIndex, title: string): ColumnType<DataType> => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
                <Input
                    ref={searchInput}
                    placeholder={`Buscar ${title}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Buscar
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Reiniciar
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes((value as string).toLowerCase()),
        onFilterDropdownOpenChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },

    });


    const columns: ColumnsType<DataType> = [
        {
            title: 'Flujo',
            dataIndex: 'flow',
            key: 'flow',
            width: 20,
            ...getColumnSearchProps('flow','Flujo'),
            sorter: (a, b) => {
                const dateA = new Date(a.flow);
                const dateB = new Date(b.flow);
    
                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }
    
                return dateA.getTime() - dateB.getTime();
            },
        },
        {
            //cOMO YO QUIERO QUE APAREZCA
            title: 'Unidad establecida FE',
            width: 30,
            //TA LCUAL COMO SE DECLARA EN EL DATATYPE
            dataIndex: 'feUnit',
            //SE ENVIA EL MISMO QUE EL DATATYPE
            key: 'feUnit',
            //MANTENER FORMATO
            //fixed: 'left',
            //BUSCADOR MODIFICADO PARA ESPANOL
           ...getColumnSearchProps('feUnit','Unidad establecida FE'),
           sorter: (a, b) => {
            const dateA = new Date(a.feUnit);
            const dateB = new Date(b.feUnit);

            if (isNaN(dateA.getTime())) {
                return -1;
            }
            if (isNaN(dateB.getTime())) {
                return 1;
            }

            return dateA.getTime() - dateB.getTime();
        },
        },
        {
            title: 'Unidad base',
            width: 30,
            dataIndex: 'baseUnit',
            key: 'baseUnit',
            //fixed: 'left',
            ...getColumnSearchProps('baseUnit','Unidad base'),
            sorter: (a, b) => {
                const dateA = new Date(a.baseUnit);
                const dateB = new Date(b.baseUnit);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },
        },
       
        {
            title: 'Unidad establecida',
            dataIndex: 'unit',
            key: 'unit',
            width: 20,
            ...getColumnSearchProps('unit','Unidad establecida'),
            sorter: (a, b) => {
                const dateA = new Date(a.unit);
                const dateB = new Date(b.unit);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },

        },
        {
            title: 'Operación',
            dataIndex: 'operation',
            key: 'operation',
            width: 30,
            ...getColumnSearchProps('operation','Operación')
        },
        {
            title: 'Dato',
            dataIndex: 'number',
            key: 'number',
            width: 20,
            ...getColumnSearchProps('number','Dato')

        },
        {
            title: 'Fuente',
            dataIndex: 'source',
            key: 'source',
            width: 20,
            ...getColumnSearchProps('source','Fuente')
        },
        {
            title: 'Creado',
            dataIndex: 'created_at',
            key: 'created_at',
            width: 30,
            defaultSortOrder: 'descend',
            sorter: (a, b) => {
                const dateA = new Date(a.created_at);
                const dateB = new Date(b.created_at);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },
        },
        {
            title: 'Modificado',
            dataIndex: 'updated_at',
            key: 'updated_at',
            width: 30,
            defaultSortOrder: 'descend',
            sorter: (a, b) => {
                const dateA = new Date(a.updated_at);
                const dateB = new Date(b.updated_at);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },

        },
    ];

    if (isRol === "ec438afc-63f2-4acf-b1d4-e51df3043190") {
        columns.push({
            title: '',
            key: 'operation',
            fixed: 'right',
            width: 10,
            render: (record: DataType) => (
                <Space size="middle">
                 <Button
                     type="text"
                     className={style["update-button"]}
                     onClick={() => handleTypeOpenModelUpdate(record.id)}
                     icon={<EditOutlined />}
                 />
             </Space>
            ),
        });
    }
    const handleCancel = () => {
        formValidate.resetFields();
        setIsModalOpen(false)
    };
    const handleTypeOpenModel = () => {
        setIsModalOpen(true)
        setTypeModal(true)
    };
    const handleTypeOpenModelUpdate = async (value: String) => {
        setIsModalOpen(true)
        setTypeModal(false)
        const responseData: TransformationSource = await props.GetTransformationById(value);
        setIdFactor(responseData.id)
        formValidate.setFieldsValue({
            flow: responseData.flow,
            feUnit: responseData.feUnit, 
            baseUnit: responseData.baseUnit,          
            unit: responseData.unit,
            operation: responseData.operation,
            number: responseData.number,
            source: responseData.source,
            description:responseData.description
        });
    };
    const onFormLayoutChange = ({ size }: { size: SizeType }) => {
        setComponentSize(size);
    };

    const onFinish = async (values: any) => {        
        
        if (!typeModal) {
            const Category = {
                id: idFactor,              
                flow: values.flow,
                feUnit: values.feUnit,
                baseUnit: values.baseUnit,
                unit: values.unit,
                operation: values.operation,           
                number: values.number,           
                source: values.source,
                description: values.description == undefined ? ' ' : values.description,
            };
            await props.putUpdateTransformation(Category);
        } else {
            const Category = {
                flow: values.flow,
                feUnit: values.feUnit,
                baseUnit: values.baseUnit,
                unit: values.unit,
                operation:values.operation,
                number:values.number,
                source: values.source,
                description:values.description == undefined ? ' ' : values.description,

              
              
            };
            await props.postRegisterTransformation(Category);
        }
        handleCancel();
        const responseData = await props.getAllTransformation();
        setDataTable(responseData);
        formValidate.resetFields();
    };

    return (
        <>
          {isRol=="ec438afc-63f2-4acf-b1d4-e51df3043190" &&  <Button
                type="primary"
                icon={<PlusCircleOutlined />}
                className={style["create-button-user"]}
                onClick={handleTypeOpenModel}
            >
                Crear Factor de tranformación
            </Button>}
            <Table size="small" columns={columns} dataSource={dataTable} scroll={{ x: 1500 }} pagination={{ pageSize: 5 }}/>
            <Drawer title= {typeModal ? "Crear Factor de transformación" : "Actualizar Factor de transformación"} open={isModalOpen} onClose={handleCancel} width={350} footer={null}>
                <Form
                    form={formValidate}
                    layout="vertical"
                    initialValues={{ requiredMarkValue: requiredMark }}
                    requiredMark={requiredMark}
                    onFinish={onFinish}
                    onValuesChange={onFormLayoutChange}
                    size={componentSize as SizeType}
                >                  
                    <Form.Item  label="Flujo" name="flow" rules={[
                        //para mantener el formato de los mensajes de informacion o error
                        { required: true, message: validateMessages.emptyField }, { validator: (_, value) => validate150(value) },
                    ]}>
                        <Input placeholder="Ingresar Flujo" />
                    </Form.Item>
                  
                    <Form.Item  label="Unidad establecida FE" name="feUnit" rules={[
                        //para mantener el formato de los mensajes de informacion o error
                        { required: true, message: validateMessages.emptyField }, { validator: (_, value) => validate150(value) },
                    ]}>
                        <Input placeholder="Ingresar unidad de emisión" />
                    </Form.Item>    
                
                    <Form.Item  label="Unidad base" name="baseUnit" rules={[
                        //para mantener el formato de los mensajes de informacion o error
                        { required: true, message: validateMessages.emptyField }, { validator: (_, value) => validate150(value) },
                    ]}>
                        <Input placeholder="Ingresar unidad base" />
                    </Form.Item>
                    <Form.Item  label="Unidad establecida" name="unit" rules={[
                        //para mantener el formato de los mensajes de informacion o error
                        { required: true, message: validateMessages.emptyField }, { validator: (_, value) => validate150(value) },
                    ]}>
                        <Input placeholder="Ingresar Flujo" />
                    </Form.Item>                

                   
                    <Form.Item  label="Operación" name="operation" rules={[
                        //para mantener el formato de los mensajes de informacion o error
                        { required: true, message: validateMessages.emptyField }, { validator: (_, value) => validate150(value) },
                    ]}>
                        <Input placeholder="Ingresar operación" />
                    </Form.Item>
                    <Form.Item  label="Número" name="number" rules={[
                        //para mantener el formato de los mensajes de informacion o error
                        { required: true, message: validateMessages.emptyField }, { validator: (_, value) => validate150(value) },
                    ]}>
                        <Input placeholder="Ingresar número" />
                    </Form.Item>
                    <Form.Item label="Fuente" name="source" rules={[
                        //para mantener el formato de los mensajes de informacion o error
                        { required: true, message: validateMessages.emptyField }, { validator: (_, value) => validate150(value) },
                    ]}>
                        <Input placeholder="Ingresar fuente" />
                    </Form.Item>
                    <Form.Item label="Descripción" name="description" rules={[
                        //para mantener el formato de los mensajes de informacion o error
                        { validator: (_, value) => validate150(value) },
                    ]}>
                        <TextArea placeholder="Ingresar descripción" />
                    </Form.Item>
                    <Form.Item>
                        <Button className={style["user-button"]} type="primary" htmlType="submit">
                            {typeModal ? "Ingresar" : "Actualizar"}
                        </Button>
                    </Form.Item>
                </Form>
            </Drawer>
        </>


    );


};

const mapStateToProps = (state: AppState) => ({

});

export default connect(mapStateToProps, {
    getAllTransformation, GetTransformationById, postRegisterTransformation, getUserByToken,putUpdateTransformation
})(TFactorst);